/**
 * WD-7 — Revoke subscription.
 * US-805 AC4: access is removed immediately and a reason is recorded.
 */
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export interface RevokeSubscriptionDialogProps {
  open: boolean
  userName: string
  planName: string
  expiresAt: string
  onConfirm: (reason: string) => Promise<void> | void
  onCancel: () => void
}

export const RevokeSubscriptionDialog = ({
  open,
  userName,
  planName,
  expiresAt,
  onConfirm,
  onCancel,
}: RevokeSubscriptionDialogProps) => {
  const translate = useAdminTranslate()

  return (
    <ConfirmDialog
      open={open}
      danger
      title={translate('admin.dialogs.revoke.title', { name: userName })}
      description={translate('admin.dialogs.revoke.description', {
        plan: planName,
        date: expiresAt,
      })}
      confirmLabel={translate('admin.dialogs.revoke.confirm')}
      requireReason
      reasonLabel={translate('admin.dialogs.revoke.reasonLabel')}
      onConfirm={reason => onConfirm(reason ?? '')}
      onCancel={onCancel}
    />
  )
}
